"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vuex = require("vuex");

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  // 1. Effets de bord
  // --
  // 2. Informations globales
  // --
  name: 'AffaireBlocInfos',
  // 3. Type de composant
  // --
  // 4. Modificateurs de template
  // --
  // 5. Dépendances des templates
  // --
  // 6. Composition
  // --
  // 7. Interface (interface du composant)
  // --
  // 8. État local (propriétés réactives locales)
  // --
  computed: _objectSpread({}, (0, _vuex.mapGetters)('affaire', ['getAffaire']), {
    affaire: function affaire() {
      return this.getAffaire;
    },
    status: function status() {
      var caption = '';
      var extra = '';

      switch (this.affaire.status) {
        case CONST.AFFAIRE.STATUS.DRAFT.value:
          caption = CONST.AFFAIRE.STATUS.DRAFT.title;
          break;

        case CONST.AFFAIRE.STATUS.TOVALIDATE.value:
        case CONST.AFFAIRE.STATUS.TOVALIDATE1.value:
        case CONST.AFFAIRE.STATUS.TOVALIDATE2.value:
          caption = 'En attente de validation';
          break;

        case CONST.AFFAIRE.STATUS.DENIED.value:
        case CONST.AFFAIRE.STATUS.DENIED1.value:
        case CONST.AFFAIRE.STATUS.DENIED2.value:
          caption = 'Refusé';
          break;

        case CONST.AFFAIRE.STATUS.SLEEPING.value:
          caption = CONST.AFFAIRE.STATUS.SLEEPING.title;
          break;

        case CONST.AFFAIRE.STATUS.ARCHIVED.value:
          caption = CONST.AFFAIRE.STATUS.ARCHIVED.title;
          break;

        case CONST.AFFAIRE.STATUS.CLOSED.value:
          caption = CONST.AFFAIRE.STATUS.CLOSED.title;
          break;

        default:
          caption = 'En cours';
      }

      switch (this.affaire.etape) {
        case CONST.AFFAIRE.ETAPE.VENTE_INITIALE.value:
          caption += ' | Vente initiale';
          break;

        case CONST.AFFAIRE.ETAPE.OBJECTIF_DEBOURSE.value:
          caption += ' | Objectifs déboursés';
          break;

        case CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.value:
          caption += ' | Budget affaire';
          break;

        case CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value:
          caption += ' | En gestion ';
          extra = this.allPeriodeGestMens;
          break;
      }

      return {
        caption: caption,
        extra: extra
      };
    }
  }) // 9. Évènements
  // --
  // 10. Propriétés non réactives
  // --
  // 11. Rendu
  // --

};
exports.default = _default;